var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        ref: "form",
        staticClass: "login-pwd-reset",
        attrs: { method: "post" },
      },
      [
        _c(
          "div",
          { staticClass: "input-unit", attrs: { "data-validate": "mail" } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email",
                },
              ],
              attrs: {
                type: "email",
                name: "email",
                autocomplete: "email",
                "data-testing": "guest-login-input",
                id: _vm._uid,
                placeholder: _vm.multiLanguage.LoginEmailPlaceholder,
                "data-autofocus": "",
              },
              domProps: { value: _vm.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.email = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: _vm._uid } }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$translate("Ceres::Template.loginEmail")) +
                  "*\n      "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "error-msg" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$translate("Ceres::Template.loginEnterConfirmEmail")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-check small my-3",
            attrs: { "data-validate": "" },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.privacyPolicyValue,
                  expression: "privacyPolicyValue",
                },
              ],
              staticClass: "form-check-input",
              attrs: {
                type: "checkbox",
                id: "privacy-policy-accept",
                name: "privacy-policy-accept",
                "data-testing": "nl-policy",
                "aria-label": "checkbox",
              },
              domProps: {
                checked: Array.isArray(_vm.privacyPolicyValue)
                  ? _vm._i(_vm.privacyPolicyValue, null) > -1
                  : _vm.privacyPolicyValue,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.privacyPolicyValue,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.privacyPolicyValue = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.privacyPolicyValue = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.privacyPolicyValue = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("label", {
              staticClass: "form-check-label",
              attrs: { for: "privacy-policy-accept" },
              domProps: { innerHTML: _vm._s(_vm.privacyPolicyText) },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mt-3" }, [
          _c(
            "button",
            {
              staticClass: "w-100 btn btn-primary btn-medium btn-appearance",
              attrs: {
                disabled: _vm.isDisabled,
                "data-testing": "guest-login-button",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.validate.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$translate("Ceres::Template.loginNext")) +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }